import { render, staticRenderFns } from "./GoogleButton.vue?vue&type=template&id=548deaee&scoped=true"
import script from "./GoogleButton.vue?vue&type=script&lang=js"
export * from "./GoogleButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548deaee",
  null
  
)

export default component.exports